module.exports = __webpack_public_path__ + "static/media/1POLICY8.cda1419e.jpg";